export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7464.f983855c.jpg";